import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from "react-toastify";
import { confirmToast } from '../../../app/components/confirmToast';
import '../../css/teacher_list.css';
import ApiService from '../../../../services/api';
import Search from '../../../../media/search.png';
import Add from '../../../../media/add.png';
import Edit from '../../../../media/edit.png';
import Delete from '../../../../media/delete.png';
import Category from '../../../../media/category.png';

const CategoryList = () => {
  const [categories, setCategories] = useState([]);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const res = await ApiService.getCategories();
        setCategories(res);
      } catch (err) {
        console.error('Errore:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchCategories();
  }, []);

  const normalizedSearch = search.trim().toLowerCase();

  const filteredCategories = categories.filter(c => {
    const catName = `${c.name}`.toLowerCase();
    return catName.includes(normalizedSearch);
});


  const handleDelete = async (slug) => {
    const category = categories.find(c => c.slug === slug);
    confirmToast({
        message: `Sei sicuro di voler eliminare la categoria ${category.name} ?`,
        type: "error",
        confirmText: "Elimina",
         onConfirm: async () => {
          try {
            await ApiService.deleteCategory(slug);
            setCategories(prev => prev.filter(t => t.slug !== slug));
            toast.success(`Categoria ${category.name} eliminata con successo`);
          } catch (err) {
            toast.error("Errore durante l'eliminazione");
                  
          }
        },
      });
     };

  return (
    <div className="teacher-list-container">
      <div className="teacher-list-header" style={{marginBottom:'50px'}}>
        <h2><img src={Category} alt="" className="section-image" /> Categorie</h2>
        <div className="search-zone">
          <img src={Search} alt="Cerca" className="search-image" />
          <input
          className='search-area'
          type="text"
          placeholder="Cerca categoria..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          />
        </div>
        <button
          className="create-button"
          onClick={() => navigate('crea')}
        >
          <img src={Add} alt="Aggiungi" className="button-image" />
        </button>
      </div>
      
      

      {loading ? (
        <p>Caricamento...</p>
      ) : categories.length === 0 ? (
        <p>Nessuna categoria disponibile</p>
      ) : (
        <ul className="teacher-list">
          {filteredCategories.map((category) => (
            <li key={category.id} className="teacher-card">
              <div className="teacher-info">
                <strong>{category.name}</strong>
              </div>
              <div className="teacher-actions">
                <button
                  className="create-button"
                  onClick={() => navigate(`modifica/${category.slug}`, { state: { categoryName: category.name } })}
                >
                  <img src={Edit} alt="Modifica" className="button-image" />
                </button>
                <button
                  className="create-button"
                  onClick={() => handleDelete(category.slug)}
                >
                  <img src={Delete} alt="Elimina" className="button-image" />
                </button>
              </div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default CategoryList;
